import { gql } from "@apollo/client"
import { ChangePartnershipTierModalItemFragment } from "@pallet/features/PartnershipType/ChangePartnershipTierModal/fragments"

export const BillingCycleSelectFragment = gql`
    fragment BillingCycleSelectFragment on CollectivePassType {
        id
        items {
            edges {
                node {
                    id
                    uuid
                    recurringEnum
                    formattedMonthlyPrice
                    discount
                    price {
                        id
                        stripeId
                        monthlyUnitAmount
                    }
                    ...ChangePartnershipTierModalItemFragment
                }
            }
        }
    }
    ${ChangePartnershipTierModalItemFragment}
`
